import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ['file', 'message']
  static values = {
    type: String
  }

  connect() {
    this.blobURLs = []
  }

  change(e) {
    const files = e.target.files
    if (!files.length) return

    const sizeInMB = files[0].size / 1024 / 1024
    if (sizeInMB > this.sizeInMB(this.typeValue)) {
      alert(`Maximum file size is ${this.sizeInMB(this.typeValue)}MB. Please choose a smaller file.`)
      e.target.value = ""
      return
    }

    this.updateMessage(files)
    this.updatePreview(files)
  }

  sizeInMB(type) {
    const sizes = {
      video: 128,
      audio: 15,
      file: 25,
      default: 5
    };
    return sizes[type] || sizes.default
  }

  updateMessage(files) {
    if (files.length === 0) {
      this.messageTarget.textContent = 'No file selected'
    } 
    else if (files.length === 1) {
      this.messageTarget.textContent = '' // files[0].name
    } 
    else {
      this.messageTarget.textContent = `${files.length} images selected`
    }
    this.messageTarget.classList.add('active')
  }

  updatePreview(files) {
    const filePreview = document.createElement('div')
    filePreview.classList.add('file-preview')

    for (let i = 0; i < files.length; i++) {
      let element

      if (this.isImage(files[i])) {
        element = this.createBgImgEl(files[i])
      } 
      else if (this.isVideo(files[i])) {
        element = this.createVideoEl(files[i])
      } 
      else if (this.isAudio(files[i])) {
        element = this.createAudioEl(files[i])
      }
      else if (this.isFile(files[i])) {
        element = this.createFileEl(files[i])
      }
      if (element) {
        filePreview.appendChild(element)
      }
    }

    this.fileTarget.innerHTML = ''
    this.fileTarget.appendChild(filePreview)
  }

  isImage(file) {
    return ["image/jpeg", "image/png", "image/gif"].includes(file.type)
  }

  isVideo(file) {
    return file.type.startsWith("video/")
  }

  isAudio(file) {
    return file.type.startsWith("audio/")
  }

  isFile(file) {
    const documentTypes = [
      "application/pdf", // PDF
      "text/csv", // CSV
      "application/msword", // DOC
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.ms-excel", // XLS
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-powerpoint", // PPT
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX
      "text/plain", // TXT
      "application/rtf", // RTF,
      "application/zip", // ZIP
    ]
    return documentTypes.includes(file.type)
  }

  createBgImgEl(file) {
    const url = URL.createObjectURL(file)
    this.blobURLs.push(url)

    const bgImg = document.createElement('div')
    bgImg.classList.add('bg-img')
    bgImg.style.backgroundImage = `url(${url})`
    return bgImg
  }

  createVideoEl(file) {
    const url = URL.createObjectURL(file)
    this.blobURLs.push(url)

    const video = document.createElement('video')
    video.src = url
    video.controls = true
    return video
  }

  createAudioEl(file) {
    const url = URL.createObjectURL(file)
    this.blobURLs.push(url)

    const audio = document.createElement('audio')
    audio.src = url
    audio.controls = true
    return audio
  }

  createFileEl(file) {
    const url = URL.createObjectURL(file)
    this.blobURLs.push(url)

    const link = document.createElement('a')
    link.href = url
    link.textContent = file.name
    link.download = file.name
    link.target = '_blank'

    return link
  }

  disconnect() {
    // Revoke blob URLs to free memory
    this.blobURLs.forEach(url => URL.revokeObjectURL(url))
    this.blobURLs = []
  }
}
